/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Delete_ButtonInputs */



/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Manual_Qc_Delete_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_delete_button = /** @type {((inputs?: Manual_Qc_Delete_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Delete_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("消去")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिटाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir")
	return /** @type {LocalizedString} */ ("Delete")
});